/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Page_Meta_TitleInputs */

const en_activity_page_meta_title = /** @type {(inputs: Activity_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity · Glider`)
};

const de_activity_page_meta_title = /** @type {(inputs: Activity_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivität · Glider`)
};

const pt_br2_activity_page_meta_title = /** @type {(inputs: Activity_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade · Glider`)
};

const tr_activity_page_meta_title = /** @type {(inputs: Activity_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik · Glider`)
};

const zh_cn2_activity_page_meta_title = /** @type {(inputs: Activity_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动 · Glider`)
};

const zh_hk2_activity_page_meta_title = /** @type {(inputs: Activity_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動 · Glider`)
};

const ko_kr2_activity_page_meta_title = /** @type {(inputs: Activity_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활동 · Glider`)
};

const ru_ru2_activity_page_meta_title = /** @type {(inputs: Activity_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активность · Glider`)
};

const es_419_activity_page_meta_title = /** @type {(inputs: Activity_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad · Glider`)
};

/**
* | output |
* | --- |
* | "Activity · Glider" |
*
* @param {Activity_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const activity_page_meta_title = /** @type {((inputs?: Activity_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activity_page_meta_title(inputs)
	if (locale === "de") return de_activity_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_activity_page_meta_title(inputs)
	if (locale === "tr") return tr_activity_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_activity_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_activity_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_activity_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_activity_page_meta_title(inputs)
	return es_419_activity_page_meta_title(inputs)
});